import { TagColor } from '@ee/common/models';

export const TAG_COLORS: { [K in TagColor]: string } = {
  red: 'rgba(213,0,0,1)',
  green: 'rgba(0,170,0,1)',
  blue: 'rgba(69,87,187,1)',
  yellow: 'rgba(186,169,63,1)',
  orange: 'rgba(255,165,0,1)',
  darkorange: 'rgba(213, 96, 0,1)',
  purple: 'rgba(132,84,253,1)',
  teal: 'rgba(0,128,128,1)',
  black: 'rgba(0,0,0,1)',
  gray: 'rgba(66,66,66,1)',
  lightgray: 'rgba(140,140,140,1)'
};

export function generateTagColorToStyle(color: TagColor): string {
  const textColor = TAG_COLORS[color] ?? TAG_COLORS['blue'];
  const bgColor = textColor.replace(',1)', ',.15)');
  return `--tag-bg:${bgColor}; --tag-text-color:${textColor}; ` +
    `--tag-remove-btn-color:${textColor}; --tag-hover:${bgColor}`;
}

